<template>
  <div class="nav">
    <a v-if="tooNarrow" href="#" @click="toggleMenu">
      {{ isMenuVisible ? 'Close' : 'Menu' }}
    </a>
    <div v-if="showMenu">
      <ul v-if="isAdmin">
        <li><router-link :to="{name: 'CalendarMonth'}">Calendar</router-link></li>
        <li><router-link :to="{name: 'ListStrips'}">Strips</router-link></li>
        <li><router-link :to="{name: 'ListPayments'}">Payments</router-link></li>
        <li><router-link :to="{name: 'ManageDiscounts'}">Discounts</router-link></li>
        <li><router-link :to="{name: 'ListSeasons'}">Seasons</router-link></li>
        <li><router-link :to="{name: 'ManageAbout'}">Site</router-link></li>
        <li><router-link :to="{name: 'ListCharacters'}">Characters</router-link></li>
        <li><router-link :to="{name: 'ManageTeam'}">Team</router-link></li>
      </ul>
      <ul v-else>
        <li><router-link :to="{name: 'Latest'}">Latest</router-link></li>
        <li><router-link :to="{name: 'First'}">First</router-link></li>
        <li><router-link :to="{name: 'Archive'}">Archive</router-link></li>
        <li><router-link :to="{name: 'Characters'}">Characters</router-link></li>
        <li><router-link :to="{name: 'About'}">About</router-link></li>
        <li v-if="showBuy"><router-link :to="{name: 'Buy'}">Buy</router-link></li>
        <li class="u-mobile-only"><router-link :to="{name: 'Login'}">Sign Up</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavMenu',
  data() {
    return {
      isMenuVisible: false,
    };
  },
  watch: {
    $route() {
      this.isMenuVisible = false;
      window.document.body.style.overflow = '';
    },
  },
  computed: {
    ...mapGetters(['isAdmin', 'getSite']),
    tooNarrow() {
      return window.innerWidth <= 600;
    },
    showMenu() {
      return this.tooNarrow ? this.isMenuVisible : true;
    },
    showBuy() {
      const options = this.getSite && this.getSite.options;
      return options && options.showBuy;
    },
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
      window.document.body.style.overflow = this.isMenuVisible ? 'hidden' : '';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.nav {
  ul {
    display: flex;
    li {
      margin: 0 10px;
    }
    .u-mobile-only {
      display: none;
      @media all and (max-width: 600px) {
        display: block;
      }
    }
    a {
      &.router-link-active {
        color: var(--color-dark);
        font-weight: 500;
        @media all and (max-width: 600px) {
          font-weight: normal;
          color: white;
          opacity: 0.5;
        }
      }
    }
    @media all and (max-width: 600px) {
      background: rgba(0,0,0,0.95);
      padding: 20px;
      border-radius: 0;
      position: fixed;
      top: 100px;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 20;
      display: block;
      li {
        border-bottom: solid 1px rgba(255,255,255,0.1);
        &:last-child {
          border-bottom: none;
        }
      }
      a {
        color: white;
        display: block;
        padding: 20px;
        text-align: center;
      }
    }
  }
}
</style>
